/* eslint-disable max-len */
import { dataService } from "../services/data.services";
import { CognitoCurrentData } from "./CognitoData";

export const handleAcademicRecordsFilterdata = async(id, selectedacademicYear, selectedclass) => {

    let associationsApiUrl = '';
    if (selectedacademicYear && selectedclass) {
        associationsApiUrl = `associations?branch_id=${id}&academic_year=${selectedacademicYear}&class_name=${selectedclass}&filter=true`;
    }

    const res=await CognitoCurrentData();
    const [yearList, classList,sectionList,exams] = await Promise.all([
        dataService.GetAPI(`academic-years?filter=true&branch_id=${id}&status=ongoing,upcoming`),
        dataService.GetAPI(`classes?branch_id=${id}&filter=true&status=true`),
        associationsApiUrl ? dataService.GetAPI(associationsApiUrl) : Promise.resolve(null),
        // dataService.GetAPI(`exams?branch_id=${id}&filter=true&status=true `)

    ]);
    return {
        classes:classList.data.data.data,
        sections:sectionList ? sectionList.data.data.data : [],
        academic_year:yearList.data.data.data,
        // exams:exams.data.data.data,
    }
};